import { 
    UPDATE_SETTINGS_FAILURE,
    UPDATE_SETTINGS_REQUEST,
    UPDATE_SETTINGS_RESET,
    UPDATE_SETTINGS_SUCCESS,
    FETCH_SETTINGS_FAILURE,
    FETCH_SETTINGS_REQUEST,
    FETCH_SETTINGS_SUCCESS
    
} from "./SettingsTypes"

const initialSettingsState = {
    settings: [],
    loading : false,
    done: false
}

export const updateSettingsReducer = (state = initialSettingsState, action) => {
    switch(action.type){
        case UPDATE_SETTINGS_RESET:
            return {
                ...state,
                done : false
            }
        case UPDATE_SETTINGS_REQUEST:
            return {
                ...state,
                loading: true
            }
        case UPDATE_SETTINGS_SUCCESS:
            return {
                loading: false,
                done : true,
                settings: [action.payload]
            }
        case UPDATE_SETTINGS_FAILURE:
            return {
                loading : false,
                settings : [],
                done : true,
                error: action.payload
            }
        default: return state;
    }
}

const initialFetchSettingsState = {
    settings : [],
    loading: false,

}

export const fetchSettingsReducer = (state = initialFetchSettingsState, action) => {
    switch (action.type) {
        case FETCH_SETTINGS_REQUEST:
            return {
                ...state,
                loading: true
            }
        case FETCH_SETTINGS_SUCCESS:
            return {
                loading: false,
                settings: [action.payload]
            }
        case FETCH_SETTINGS_FAILURE:
            return {
                loading: false,
                settings: [],
                error: action.payload
            }
        default: return state;
    }
}